import React, { useState, useEffect } from "react";
import algoliasearch from "algoliasearch/lite";
import { useParams, useLocation } from "react-router-dom";
import UserProfileCard from "../Header/userProfileCard";
import { UserAuth } from "../Context";
import useLogActivity from "../hooks/user/useLogActivity";
//algolia object initialization and index mapping
const client = algoliasearch(
  process.env.REACT_APP_ALGOLIA_APP_ID,
  process.env.REACT_APP_ALGOLIA_ADMIN_KEY
);
const indexUsers = client.initIndex("users"); // Name of index in Algolia is users

export default function Users() {
  //**********************  Router Functions  **********************************//
  const location = useLocation();
  const { input } = useParams();

  //*********************** other states     *************************************/
  const [allUsers, setAllUsers] = useState([]); // Corrected line
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage] = useState(12);
  const [loading, setLoading] = useState(true);
  const [countLeftUser, setCountLeftUser] = useState(false);
  const [paramInput, setParamInput] = useState(input);
  const [totalUserCount, setTotalUserCount] = useState(0); //total User count
  const { user } = UserAuth();
  const { logActivity } = useLogActivity(user?.uid);
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  const [result, setResult] = useState(false);

  //******************************* Functions **********************************************/
  useEffect(() => {
    console.log("Page count in useeffect", currentPage);
    setResult(false);
    setCurrentPage(0);
    setParamInput(input);
    retrieveData(0);
    setResult(true);
    setCurrentPage(currentPage + 1);
  }, [location.pathname, input]); //only updates when user refreshes

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //function fires when user loads
  const handleLoad = () => {
    if (!loading) {
      setResult(false);
      setLoading(true);
      setCurrentPage(currentPage + 1);
      retrieveData(currentPage + 1); // Fetch data for the next page
      setResult(true);
    }
  };

  //**********************   Handle Load More ********************************************/
  // ****************** async call to retrieve data **************************************/
  const retrieveData = async (page) => {
    if (input.length >= 3) {
      try {
        const offset = page * itemsPerPage;
        const data = await indexUsers.search(input, {
          offset,
          length: itemsPerPage,
          typoTolerance: "strict", // Enable strict typo tolerance
          // Contexts:['firstName', 'lastName', 'email', 'userName'], // Searchable contexts
          synonyms: false, // Disable synonyms
        });

        // // Create a Set to store unique users based on a unique identifier (e.g., user ID)
        // const uniqueUserSet = new Set(allUsers.map(user => user.email));

        // // Filter out duplicates and convert back to an array
        // const uniqueUsers = data.hits.filter(user => !uniqueUserSet.has(user.email));
        console.log("Data hits in search", data.hits);
        setLoading(false);
        setAllUsers([...allUsers, ...data.hits]);
        setTotalUserCount(data.nbHits);
        setCountLeftUser(data.nbHits > offset + itemsPerPage);

        const activityData = {
          input,
          page,
          type: "userSearch",
        };

        logActivity(activityData);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    }
  };
  console.log("value of current page :", currentPage);
  return (
    <>
      {allUsers.length > 0 && (
        <>
          <div
            className="d-flex flex-column w-100 px-md-0"
            style={{ gap: "16px", padding: "0px 6px" }}
          >
            <div
              style={{
                fontFamily: "Inter",
                fontWeight: "500",
                fontSize: "22px",
                lineHeight: "100%",
                letterSpacing: "0%",
                color: "#000000",
              }}
            >
              Users
            </div>
            <div className="row mx-0">
              {allUsers.length &&
                allUsers?.map((searchUser, index) => (
                  <div
                    className="col-6 col-sm-6 col-md-4 col-lg-2 m-0"
                    style={{
                      padding: isSmallScreen
                        ? index % 2 === 0
                          ? "6px 6px 6px 0px"
                          : index % 2 === 1
                          ? "6px 0px 6px 6px"
                          : "6px 6px"
                        : index % 6 === 0
                        ? "6px 6px 6px 0px"
                        : index % 6 === 5
                        ? "6px 0px 6px 6px"
                        : "6px 6px",
                    }}
                  >
                    <UserProfileCard
                      key={index}
                      searchUser={searchUser}
                      user={user}
                      componentName={"Users"}
                    />
                  </div>
                ))}
            </div>
            <button
              className={`btn btn-loader mt-12 btn-primary-soft ${
                loading ||
                !countLeftUser ||
                totalUserCount <= currentPage * itemsPerPage
                  ? "disabled"
                  : ""
              }`}
              onClick={handleLoad}
            >
              {loading ? (
                <div className="spinner-grow spinner-grow-sm" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              ) : (
                <span className="load-text">
                  {countLeftUser ? "Load more" : "No More Users to show"}
                </span>
              )}
            </button>
          </div>
        </>
      )}
    </>
  );
}
